import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteAtmType = ({ atmTypeId }: { atmTypeId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/AtmTypes/DeleteAtmType/${atmTypeId}`);
};

type QueryFnType = typeof deleteAtmType;

type UseDeleteAtmTypeOptions = {
  atmTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteAtmType = ({ config }: UseDeleteAtmTypeOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllAtmTypes"]);
      addNotification(`Ο Τύπος Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteAtmType,
  });
};
